import React from "react";
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import Footer from "./Footer";
// import exploreImage from './exploreimage.jpg'

const Explore = () => {
  const navigate = useNavigate();
  const exploreBtn = () => {
    navigate("/articles");
  };
  return (
    <>
      <Container fluid className="explore-container text-center">
        <Row>
          <Col className="explore-content">
            <h1 className="explore-heading">
              Unleash Your Creative Writing Potential
            </h1>
            <button onClick={exploreBtn} className="transparent-btn">
              Explore<span className="px-1"></span>
              <FaArrowRight />
            </button>
          </Col>
        </Row>
      </Container>

      <Footer />
    </>
  );
};

export default Explore;
